import ReviewsActions from '../actions/reviewsActions';
import ListingActions from '../actions/listingActions';
import EdapActions from '../actions/edapActions';

function viewAllReviews(store, action = {payload: {}}) {
    const {uuid} = action.payload;
    const reviewId = typeof uuid === 'string' && uuid.length > 0 ? uuid : '';

    store.dispatch(ReviewsActions.expandReviewClicked(reviewId));
    store.dispatch(ListingActions.setReviewsModalOpen(true));
    store.dispatch(
        EdapActions.triggerEdapEvent('generic.modal', {
            modalname: 'reviews',
            modalaction: 'open'
        })
    );
}

export default {viewAllReviews};
export {viewAllReviews};
